export class clientRoutes {
  static agentRegister = "/";
  static createProperties = "/properties/create";
  static agentSignIn = "/agent/sign-in";
  static agentSignInVerifyEmail = "/agent/login/verify-email";
  static agencySignInVerifyEmail = "/agency/login/verify-email";

  static agentProfileVerifyPhone = "/agent/create-profile/verify-phone";
  static agentProfileAgencyInfo = "/agent/create-profile/agency-info";
  static agentProfileCreateAgencyProfile = "/agent/create-agency-profile";

  static agentCreateAgencyInfo = "/agent/create-agency-profile/agency-info";
  static agentCreateAgencyVerifyPhone =
    "/agent/create-agency-profile/verify-phone";
  static agentCreateAgencyLegalInfo = "/agent/create-agency-profile/legal-info";
  static agentCreateAgencyBrandGrammar =
    "/agent/create-agency-profile/brand-grammar";
    static agentCreateAgencyAgentInfo =
    "/agent/create-agency-profile/agent-info";

  static dashboardHome = "/properties";

  static home = "/";
  static testComponent = "/test-component";
  static dashboard = "/dashboard";
  static properties = "/properties";
  static workspace = "/workspace";
  static subscription = "/subscription";
  static ledger = "/ledger";
  static manageSubscriptions = "/manage-subscriptions";
  static propertyPlans = "/manage-subscriptions/property-plans";
  static agentPlans = "/manage-subscriptions/agent-plans";
  static paymentHistory = "/payment-history";

  static agencyEmployeeList = "/agency-employee";
  static createAgencyEmployeeList = "/agency-employee/create";
  static agencyViewEmployee = "/agency-employee/view/:id";

  static agentEmployeeList = "/agent-employee";
  static createAgentEmployeeList = "/agent-employee/create";
  static agentViewEmployee = "/agent-employee/view/:id";

  static agencyAgentEmployeeList = "/agency-agent-employee";
  static createAgencyAgentEmployeeList = "/agency-agent-employee/create";
  static agencyAgentViewEmployee = "/agency-agent-employee/view/:id";

  static allActivities = "/workspace/all-activities";
  static WorkspaceSchedule = "/workspace/schedule-auction";
  static PropertyPost = "/workspace/property-post";
  static agentPropertyPost = "/workspace/agent-marketing/create";
  static WorkspaceScheduleList = "/workspace/schedule-auction-list";
  static ScheduleOpenHomeList = "/workspace/schedule-open-home-list";
  static PropertyPostList = "/workspace/property-post-list";
  static OnBoardingPostList = "/workspace/onboarding-post-list";
  static AgentPropertyPostList = "/workspace/agent-marketing/property-posts";
  static ReviewPostList = "/workspace/review-post-list";
  static WorkspaceCreatereviewPost = "/workspace/create-review-post";
  static OnBoardingPost = "/workspace/create-onboarding-post";
  static WorkspaceSheduleConfigure = "/workspace/auction/SheduleConfigure";
  static scheduleOpenHome = "/workspace/schedule-open-home";
  static AgencyOpenHomeList = "/workspace/agency-schedule-open-home-list";
  static AgencyPropertyPost = "/workspace/agency-property-post-list";
  static AgencyReviewPost = "/workspace/agency-review-post-list";
  static AgencyAuctionPost = "/workspace/agency-auction-list";
  static propertieView = "/properties/view/:id";
  static propertieEdit = "/properties/edit/:id";
  static scheduleOpenHomeView =
    "/workspace/schedule-open-home/view/:scheduleId";
  static AgencyScheduleOpenHomeView =
    "/workspace/agency-schedule-open-home/view/:scheduleId";
  static AgencyPropertyPostView =
    "/workspace/agency-property-post/view/:propertyPostId";
  static AgencyScheduleAuctionView =
    "/workspace/agency-schedule-auction/view/:scheduleId";
  static AgencyReviewPostView =
    "/workspace/agency-review-post/view/:reviewPostId";
  static PropertyPostView =
    "/workspace/property-post-list/view/:propertyPostId";
  static PropertyPostJourneyView =
    "/workspace/property-post-list/journey-view/:propertyPostId";
  static CoAgentPropertyPostView =
    "/workspace/property-post-list/co-agent/view/:propertyPostId";
  static AgentPropertyPostView =
    "/workspace/agent-marketing/property-posts/:propertyPostId";
  static CoAgentPropertyView =
    "/workspace/agent-marketing/property-post/co-agent/view/:propertyPostId";
  static ScheduleAuctionView = "/workspace/schedule-auction/view/:scheduleId";
  static ReviewPostView = "/workspace/review-post-list/view/:reviewPostId";
  static OnboardingPostView =
    "/workspace/onboarding-post/view/:onboardingPostId";
  static AnnouncementPost = "/workspace/create-announcement-post";
  static AnnouncementPostView =
    "/workspace/announcement-post/view/:announcementPostId";
  static AnnouncementPostList = "/workspace/announcement-post-list";

  static NewPropertyPost = "/workspace/new-property-post";
  static NewPropertyPostList = "/workspace/new-property-post-list";
  static NewPropertyPostView =
    "/workspace/new-property-post-list/view/:propertyPostId";

  static FestivalPost = "/workspace/create-festival-post";
  static FestivalPostView = "/workspace/festival-post/view/:festivalPostId";
  static FestivalPostList = "/workspace/festival-post-list";

  static AgencyAnnouncementPost = "/workspace/agency-create-announcement-post";
  static AgencyAnnouncementPostView =
    "/workspace/agency-announcement-post/view/:announcementPostId";
  static AgencyAnnouncementPostList =
    "/workspace/agency-announcement-post-list";

  static AgencyFestivalPost = "/workspace/agency-create-festival-post";
  static AgencyFestivalPostView =
    "/workspace/agency-festival-post/view/:festivalPostId";
  static AgencyFestivalPostList = "/workspace/agency-festival-post-list";

  static AgencyOnboardingPost = "/workspace/agency-create-onboarding-post";
  static AgencyOnboardingPostView =
    "/workspace/agency-onboarding-post/view/:onboardingPostId";
  static AgencyOnboardingPostList = "/workspace/agency-onboarding-post-list";

  static PropertyCheckoutSuccess = "/property-plan/success";
  static PropertyCheckoutFailed = "/property-plan/failed";

  static AgentMarketingCheckoutSuccess = "/agent-marketing-plan/success";
  static AgentMarketingCheckoutFailed = "/agent-marketing-plan/failed";

  static PropertyPostViaCheckoutSuccess = "/property-post-via-plan/success";

  static AgentPropertyPostViaCheckoutSuccess =
    "/agent-property-post-via-plan/success";

  static OpenHomePostViaCheckoutSuccess = "/open-home-post-via-plan/success";

  static AuctionPostViaCheckoutSuccess = "/auction-post-via-plan/success";

  static PropertyUpgradeCheckout = "/upgrade-property-plan/success";
  static PropertyUpgradeCheckoutFailed = "/upgrade-property-plan/failed";

  static agentProfileView = "/agent-profile";
  static agencyProfileView = "/agency-profile";

  static agentJoiningRequests = "/agents/agent-joining-requests";
  static agentRequestsView = "/agents/agent-joining-requests/view/:id";

  static agents = "/agents";
  static agentViewAndEdit = "/agents/:id";

  static manageInvites = "/manage-invites";

  static manageInvitesDetails = "/manage-invites/details/:id";

  static designTemplates = "/design-templates";

  static designTemplateTypes = "/design-template-types";

  static masterdesignTemplateconfiguration = "/master-design-configuration";

  // static designAnnoucementTemplateTypes = "/design-announcement-template-types";
  // static designFestivalTemplateTypes = "/design-festival-template-types";

  static agencyApprovalWaiting = "/agency-approval-waiting";
  static adminApprovalWaiting = "/admin-approval-waiting";
  static agentAgencyApprovalWaiting = "/agent-agency-approval-waiting";

  static accountSettings = "/account-settings";

  static configurePropertyStages =
    "/account-settings/configure-property-stages";
  static openHomePosts = "/account-settings/open-home-posts";
  static auctionPosts = "/account-settings/auction-posts";
  static recapPostSettings = "/account-settings/recap-post-settings";
  static otherPostSettings = "/account-settings/other-post-settings";
  static paymentMethods = "/account-settings/payment-methods";
  static socialMediaAccounts = "/account-settings/social-accounts";
  static security = "/account-settings/security"
  // static manageSubscriptions = "/account-settings/manage-subscriptions";
  static Ledger = "/account-settings/ledger";

  // static register = "/registration-session";
  static register = "/register";
  static login = "/login";
  static agentVerifyEmail = "/register/agent/verify-email";
  static agentProfile = "/agent/create-profile/agent-info";
  static agentVerifyPhone = "/agent/create-profile/verify-phone";

  static agencyVerifyEmail = "/register/agency/verify-email";
  static agencyProfileAgencyInfo = "/agency/create-profile/agency-info";
  static agencyProfileVerifyPhone = "/agency/create-profile/verify-phone";
  static agencyProfileLegalInfo = "/agency/create-profile/legal-info";
  static agencyBrandGrammerInfo = "/agency/create-profile/brand-grammer-info";
  static agencyProfileAgentInfo = "/agency/create-profile/agent-info";
  static agencyVerifyPhone = "/agency/verify-phone";
}
